/**
 * Atributos de los enlaces que salen de Athena hacia un estudio o hacia la web de su editor.
 *
 * La web envía `Referrer-Policy: same-origin` (`render.yaml`), así que por defecto ningún sitio externo sabe que la
 * visita llega desde Athena. Estos enlaces sí lo dicen, pero solo con el origen (`https://athena.sinapser.com/`): el
 * editor ve en sus estadísticas el tráfico que le manda Athena, y la ruta de la página no sale nunca. `noopener` se
 * queda: la pestaña del estudio no puede tocar la de Athena.
 */
export const ENLACE_A_EDITOR = { target: '_blank', rel: 'noopener', referrerPolicy: 'strict-origin' } as const;
